import use561PreReviewSubmit from '@/composables/preReviewSubmit/use561PreReviewSubmit.js'
import use580PreReviewSubmit from '@/composables/preReviewSubmit/use580PreReviewSubmit.js'
import use401PreReviewSubmit from '@/composables/preReviewSubmit/use401PreReviewSubmit.js'
import use784PreReviewSubmit from '@/composables/preReviewSubmit/use784PreReviewSubmit.js'
import use995PreReviewSubmit from '@/composables/preReviewSubmit/use995PreReviewSubmit.js'
import useReviewToFingerprintSubmit from '@/composables/preReviewSubmit/useReviewToFingerprintSubmit.js'
import { useAuthStore } from '@/stores/auth'

export default async function (serviceId, payload) {
  const authStore = useAuthStore()
  const {
    user: { applicationId = '' }
  } = authStore
  const gcc_citizen = {
    995: use995PreReviewSubmit
  }
  const mapping = {
    561: use561PreReviewSubmit,
    580: use580PreReviewSubmit,
    401: use401PreReviewSubmit,
    870: useReviewToFingerprintSubmit,
    784: use784PreReviewSubmit,
    784: use784PreReviewSubmit,
    ...(applicationId == 7 && gcc_citizen)
  }
  if (
    Object.keys(mapping)
      .map((m) => +m)
      .includes(+serviceId)
  ) {
    return await mapping[serviceId](payload)
  }

  console.info(`There's no pre review submit mapped for ${serviceId}`)
  return Promise.resolve({})
}
